import { render, staticRenderFns } from "./AltriDati.vue?vue&type=template&id=2b855932"
import script from "./AltriDati.vue?vue&type=script&lang=js"
export * from "./AltriDati.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports